<template>
    <nav class="nav has-shadow app-navbar">
        <div class="container">
            <div class="nav-left">
                <router-link class="nav-item logo" :to="{ name: 'home', params: {lang: lang} }" :class="{bvcd: HAS_BVCD}">
                    <img v-if="HAS_BVCD" src="/static/img/misc/changer_logo.svg" width="89" height="36" :alt="$t('generic.bvcd')" :title="logoTitleWithCommit" border="0"/>
                    <img v-else src="/static/img/misc/changer_logo.svg" width="89" height="36" :alt="$t('generic.ci')" :title="logoTitleWithCommit" border="0"/>
                </router-link>
                <h2 class="campground__name is-hidden-mobile" :class="{bvcd: HAS_BVCD}" v-if="campground" :title="campground.slug">{{ campground.name }}</h2>
            </div>

            <div class="nav-center">
                <span class="nav-item published-state tooltip-activator">
                    <span class="published-state-label">{{ $t('status.label') }}</span>
                    <publish-switch v-model="published" @clicked="onPublishSwitchClicked" />
                    <div
                        v-if="!published && campground && campground.legal_documents.to_accept.length > 0"
                        class="tooltip tooltip--is-bottom-left tooltip--is-large"
                    >
                        {{ $t('status.publishNotAllowed.content.documents') }}
                    </div>
                </span>
            </div>

            <span class="nav-toggle" @click.stop.prevent="toggleNavMenu()">
                <span></span>
                <span></span>
                <span></span>
            </span>
            <div class="nav-right nav-menu" :class="{ 'is-active': showNavMenu }">
                <ul class="menu-list is-hidden-tablet">
                    <li v-for="item in navItems">
                        <router-link :to="{ name: item.path, params: {lang: lang} }" :exact="item.isExact">
                           <span class="icon is-small">
                                <i class="fa" :class="[item.icon]" aria-hidden="true"></i>
                           </span>
                            {{ item.name }}

                            <template v-for="child in item.children">
                                <span
                                    class="icon is-small is-pulled-right"
                                    v-if="evaluate(child.condition)"
                                >
                                    <i class="fa fa-fw"
                                       :class="child.icon"
                                       aria-hidden="true"
                                       @click.prevent="showModal(child)"
                                    />
                                </span>
                            </template>
                        </router-link>
                    </li>
                    <li>
                        <span class="nav-item is-flex language-span">
                            <span class="icon icon-offset-right">
                                <i class="fa fa-language" aria-hidden="true"></i>
                            </span>
                            <span class="select">
                                <select v-model="selectedLanguage">
                                    <option v-for="(value, key) in selectableLanguages" :value="key">
                                      {{ value }}
                                    </option>
                                </select>
                            </span>
                        </span>
                    </li>
                    <li>
                        <router-link exact :to="{ name: 'profile', params: {lang: lang} }">
                             <span class="icon is-medium">
                                <figure class="image is-24x24" v-html="profilePicture"></figure>
                            </span>
                                {{ $t('profile.intro.headline') }}
                        </router-link>
                    </li>
                    <li>
                        <router-link exact class="nav-item is-flex" :to="{ name: 'logout' }">
                            <span class="icon">
                                <i class="fa fa-lock" aria-hidden="true"></i>
                            </span>
                            {{ $t('generic.logout') }}
                        </router-link>
                    </li>
                </ul>
                <span class="select campground-select is-hidden-tablet">
                    <select @change="changeCampground">
                        <option v-for="option in campgrounds" :value="option.slug" :selected="campground.slug == option.slug">
                        {{ option.name }}
                        </option>
                    </select>
                </span>

                <span class="select lang-select nav-item is-hidden-mobile">
                    <span class="icon icon-offset-right">
                        <i class="fa fa-language" aria-hidden="true"></i>
                    </span>
                    <select v-model="selectedLanguage">
                        <option v-for="(value, key) in selectableLanguages" :value="key">
                          {{ value }}
                        </option>
                    </select>
                </span>

                <router-link exact class="nav-item is-hidden-mobile" :to="{ name: 'profile', params: {lang: lang} }">
                    <figure class="image is-24x24" v-html="profilePicture"></figure>
                    {{ $t('profile.intro.headline') }}
                </router-link>

                <router-link exact class="nav-item is-flex is-hidden-mobile" :to="{ name: 'logout' }">
                    <span class="icon">
                        <i class="fa fa-lock" aria-hidden="true"></i>
                    </span>
                    {{ $t('generic.logout') }}
                </router-link>
            </div>
        </div>
        <div class="modal" :class="{ 'is-active': modal.isActive }">
            <div class="modal-background" @click="closeModal()"></div>
            <div class="modal-card">
                <header class="modal-card-head">
                    <p class="modal-card-title">{{ modal.title }}</p>
                    <button class="delete" @click="closeModal()"></button>
                </header>
                <section class="modal-card-body" v-html="modal.content">
                </section>
                <footer class="modal-card-foot is-clearfix">
                    <a class="button" @click="closeModal()">{{ $t('generic.cancel') }}</a>
                    <a class="button is-danger" v-if="published && modal.button" @click="changeStatus()"
                       :class="{ 'is-loading': modal.isLoading }" :disabled="modal.isLoading">
                        <span class="icon">
                            <i class="fa fa-ban" aria-hidden="true"></i>
                        </span>
                        <span v-html="modal.button"></span>
                    </a>
                    <a class="button is-success" v-if="!published && modal.button" @click="changeStatus()"
                       :class="{ 'is-loading': modal.isLoading }" :disabled="modal.isLoading">
                        <span class="icon">
                            <i class="fa fa-check-circle" aria-hidden="true"></i>
                        </span>
                        <span v-html="modal.button"></span>
                    </a>
                </footer>
            </div>
        </div>

        <Modal
            ref="modal"
            :title="$t('generic.formErrorHeadline')"
        >
            <ul class="modal__list">
                <li
                    :key="content"
                    v-for="content in modalContent"
                >
                    {{ content }}
                </li>
            </ul>

            <template #footer>
                <button
                    class="button is-primary"
                    @click="toggleModal"
                >
                    {{ $t('generic.close') }}
                </button>
            </template>
        </Modal>
    </nav>
</template>

<script>
    import { Api } from '../../../api';
    import { AppModel } from '../../../models';
    import { EventBus, Tracking } from '../../../utils';
    import { PublishSwitch } from '../';
    import Modal from '../modal/modal.vue';

    export default {
        name: 'navbar',

        components: {
            PublishSwitch,
            Modal,
        },

        props: ['campground', 'campgrounds', 'checks'],

        data() {
            return {
                modalContent: null,
                navItems: [{
                    path: 'home',
                    icon: 'fa-eye',
                    name: this.$t('generic.menu.overview'),
                    isExact: true
                }, {
                    path: 'bookings',
                    icon: 'fa-list-alt',
                    name: this.$tc('generic.menu.bookings.bookings', 2)
                },
                {
                    path: 'availabilities-redirect',
                    icon: 'fa-table',
                    name: this.$t('generic.menu.availabilities'),
                    children: [{
                        condition: 'this.hasAvailabilityCheck && this.checks && !this.checks.availabilities',
                        icon: 'fa-exclamation-triangle is-invalid',
                    }]
                },
                // {
                //     path: 'payments',
                //     icon: 'fa-money',
                //     name: this.$t('generic.menu.payments'),
                // }, {
                //     path: 'invoices',
                //     icon: 'fa-file-pdf-o',
                //     name: this.$t('generic.menu.invoices'),
                // },
                {
                    path: 'dayprices',
                    icon: 'fa-money',
                    name: this.$t('generic.menu.pricelist'),
                },
                // {
                //     path: 'seasons',
                //     icon: 'fa-calendar',
                //     name: this.$t('generic.menu.seasons'),
                //     children: [{
                //         condition: 'this.checks && !this.checks.seasons',
                //         warnings: 'this.checks.seasons_warnings',
                //         errors: 'this.checks.seasons_errors',
                //         icon: 'fa-exclamation-triangle is-invalid',
                //     }]
                // },
                {
                    path: 'cancellation-terms',
                    icon: 'fa-list-ol',
                    name: this.$t('generic.menu.cancellation.sidebar'),
                    children: [{
                        condition: 'this.checks && !this.checks.cancellations',
                        warnings: 'this.checks.cancellations_warnings',
                        icon: 'fa-exclamation-triangle is-invalid',
                    }]
                },
                {
                    path: 'campsites',
                    icon: 'fa-map-marker',
                    name: this.$t('generic.menu.campsites'),
                    children: [{
                        condition: 'this.checks && !this.checks.campsites',
                        warnings: 'this.checks.campsites_warnings',
                        errors: 'this.checks.campsites_errors',
                        icon: 'fa-exclamation-triangle is-invalid',
                    }]
                }, {
                    path: 'pms-accommodations',
                    icon: 'fa-home',
                    name: this.$t('pms.menuLabel'),
                    condition: 'this.owner_frontend_config && this.owner_frontend_config.pms_objects',
                }, {
                    path: 'persons',
                    icon: 'fa-user-circle',
                    name: this.$t('generic.menu.persons'),
                    children: [{
                        condition: 'this.checks && !this.checks.persons',
                        warnings: 'this.checks.persons_warnings',
                        errors: 'this.checks.persons_errors',
                        icon: 'fa-exclamation-triangle is-invalid',
                    }]
                }, {
                    path: 'extras',
                    icon: 'fa-plus-circle',
                    name: this.$t('generic.menu.extras'),
                    children: [{
                        condition: 'this.checks && !this.checks.extras',
                        warnings: 'this.checks.extras_warnings',
                        errors: 'this.checks.extras_errors',
                        icon: 'fa-exclamation-triangle is-invalid',
                    }]
                }, {
                    path: 'portals',
                    icon: 'fa-laptop',
                    name: this.$t('generic.menu.portals'),
                }, {
                    path: 'translations',
                    icon: 'fa-globe',
                    name: this.$t('generic.menu.translations'),
                    children: [{
                        condition: 'this.checks && !this.checks.translations',
                        warnings: 'this.checks.translations_warnings',
                        errors: 'this.checks.translations_errors',
                        icon: 'fa-exclamation-triangle is-invalid',
                    }]
                }, {
                    path: 'settings',
                    icon: 'fa-cogs',
                    name: this.$t('generic.menu.settings'),
                    children: [{
                        condition: 'this.checks && !this.checks.settings',
                        warnings: 'this.checks.settings_warnings',
                        errors: 'this.checks.settings_errors',
                        icon: 'fa-exclamation-triangle is-invalid',
                    }]
                }],
                SERVICE_EMAIL_LINK: AppModel.serviceEmailLink,
                HAS_BVCD: AppModel.hasBvcd,
                hasAvailabilityCheck: false,
                showNavMenu: false,
                gravatarUrl: 'https://www.gravatar.com/avatar/00000000000000000000000000000000.jpg',
                published: false,
                selectedLanguage: null,
                modal: {
                    isActive: false,
                    title: null,
                    content: null,
                    button: null,
                    isLoading: false,
                },
            };
        },

        computed: {
            profilePicture() {
                return `<img src="${this.gravatarUrl}?s=24&d=mm" border="0" />`;
            },
            lang() {
                return AppModel.lang;
            },

            selectableLanguages() {
                return AppModel.systemLanguages;
            },
            logoTitleWithCommit() {
                const version = process.env.VUE_APP_COMMIT_TAG || '-';
                const buildDate = process.env.VUE_APP_BUILD_DATE || '-';
                const company = this.$t('generic.bvcd');
                if(version && buildDate) {
                    return `${company}\nVersion: ${version}\nDate: ${buildDate}`;
                }
                return company;
            }
        },

        watch: {
            '$route'(to, from) {
                if(to.name !== from.name) {
                    this.showNavMenu = false;
                }
                if(to.params.lang !== from.params.lang && to.params.lang !== AppModel.lang) {
                    AppModel.setLang(to.params.lang);
                    window.location.reload();
                }
            },

            selectedLanguage(newVal) {
                if(this.$route.params.lang !== newVal) {
                    this.$router.push(this.getLanguageLink(newVal));
                }
            }
        },

        created() {
            EventBus.$on(EventBus.BOOTSTRAP_DONE, this.onBootstrapDone);
            EventBus.$on(EventBus.CAMPGROUND_CHANGED, this.initPublishSwitch);
            EventBus.$on(EventBus.UPDATE_CHECKS_DONE, this.initPublishSwitch);
            this.selectedLanguage = this.lang;
            this.initPublishSwitch();
        },

        methods: {
            getLanguageLink(lang) {
                const p = window.location.pathname;
                if(p.match(/^\/[a-z]{2}$/)) {
                    return `/${lang}${window.location.search}`;
                }
                return (window.location.pathname + window.location.search).replace(/^\/[a-z]{2}\//, `/${lang}/`);
            },
            toggleNavMenu() {
                this.showNavMenu = !this.showNavMenu;
                Tracking.trackEvent('NavigationBar', 'toggleNavigation', null, this.showNavMenu);
            },

            onBootstrapDone() {
                if(AppModel.activeCampground) {
                    this.gravatarUrl = AppModel.user.gravatar_url;
                    this.hasAvailabilityCheck = AppModel.activeCampground.settings.pms_api_active;
                    this.initPublishSwitch();
                }
            },

            changeCampground(event) {
                this.$router.push({name: 'change-campground', params: {campground: event.target.value}});
            },

            initPublishSwitch() {
                if(AppModel.activeCampground) {
                    this.published = AppModel.activeCampground.published;
                }
            },

            onPublishSwitchClicked() {
                if(!this.published && this.campground.legal_documents.to_accept.length > 0) {
                    return;
                }

                this.modal.isActive = true;
                if(this.published) {
                    this.modal.title = this.$t('status.unpublish.title');
                    this.modal.content = this.$t('status.unpublish.content');
                    this.modal.button = this.$t('status.unpublish.button');
                    Tracking.trackEvent('NavigationBar', 'updatePublishStatus', 'setOffline', null);
                } else {
                    if(!AppModel.activeCampground.contract_type) {
                        this.modal.button = null;
                        this.modal.title = this.$t('status.publishNotAllowed.title');
                        let bvcdOrCi = 'ci';
                        if(this.HAS_BVCD) {
                            bvcdOrCi = 'bvcd';
                        }
                        this.modal.content = this.$t(`status.publishNotAllowed.content.${bvcdOrCi}`, {SERVICE_EMAIL_LINK: this.SERVICE_EMAIL_LINK});
                        Tracking.trackEvent('NavigationBar', 'updatePublishStatus', 'setOnlineNoContract', null);
                    } else {
                        this.modal.title = this.$t('status.publish.title');
                        this.modal.button = this.$t('status.publish.title');

                        if(AppModel.allChecksOkay) {
                            this.modal.content = this.$t('status.publish.content');
                            Tracking.trackEvent('NavigationBar', 'updatePublishStatus', 'setOnlineSettingSuccess', null);
                        } else if(AppModel.settingsCheckOkay) {
                            this.modal.content = this.$t('status.publish.contentIncomplete');
                            Tracking.trackEvent('NavigationBar', 'updatePublishStatus', 'setOnlineSettingsFailed', null);
                        } else {
                            this.modal.content = this.$t('status.publish.forbidden');
                            this.modal.button = '';
                            Tracking.trackEvent('NavigationBar', 'updatePublishStatus', 'setOnlineForbidden', null);
                        }
                    }
                }
            },

            closeModal() {
                this.modal.isActive = false;
            },

            changeStatus() {
                this.modal.isLoading = true;
                if(this.published) {
                    Api.setCampgroundPublished(false).then((response) => {
                        EventBus.$emit(EventBus.SHOW_NOTIFICATION, {
                            title: this.$t('generic.saveSuccessHeadline'),
                            body: this.$t('generic.notifications.unpublished.body'),
                            direction: 'Up',
                            duration: 10000,
                        });
                        this.published = false;
                        this.changeStatusFinished();
                    }, () => {
                        console.error('update failed');
                        this.changeStatusFinished();
                    });

                    Tracking.trackEvent('NavigationBar', 'updatePublishStatus', 'offline', null);
                } else {
                    Api.setCampgroundPublished(true).then((response) => {
                        if(response.status >= 400) {
                            EventBus.$emit(EventBus.SHOW_NOTIFICATION, {
                                title: this.$t('generic.formErrorHeadline'),
                                body: response.body.published[0],
                                direction: 'Up',
                                type: 'danger',
                                duration: 10000,
                            });
                            this.published = false;
                            this.changeStatusFinished();
                            return;
                        }
                        EventBus.$emit(EventBus.SHOW_NOTIFICATION, {
                            title: this.$t('generic.saveSuccessHeadline'),
                            body: this.$t('generic.notifications.published.body'),
                            direction: 'Up',
                            duration: 10000,
                        });
                        this.published = true;
                        this.changeStatusFinished();
                    }, () => {
                        console.error('update failed');
                        this.changeStatusFinished();
                    });

                    Tracking.trackEvent('NavigationBar', 'updatePublishStatus', 'online', null);
                }
            },

            changeStatusFinished() {
                this.modal.isActive = false;
                this.modal.isLoading = false;
            },

            evaluate(str) {
                if(typeof str !== 'string') return true;
                // eslint-disable-next-line no-eval
                return eval(str);
            },
            showModal(data) {
                this.toggleModal();
                this.modalContent = this.evaluate(data.warnings) || this.evaluate(data.errors);
            },
            toggleModal() {
                this.$refs.modal.toggleModal();
            }
        }
    };
</script>

<style lang="scss">
    @import './navbar.scss';
</style>

<style lang="scss" scoped>
.modal {
    &__list {
        list-style: initial;
        margin-left: 2rem;
    }
}
</style>



// WEBPACK FOOTER //
// src/views/components/navbar/navbar.vue